import React from 'react'
import FlatListing from './header/FlatListing'
import LayoutSection from './layout/layout'

const ShowPropertyGalleryPage = () => {
  return (
    <div className='my-[130px] max-w-[96%] mx-auto'>
        <FlatListing/>
        <LayoutSection/>
    </div>
  )
}

export default ShowPropertyGalleryPage